const selectors = {
  subTabMain: '.sub_tab_main',
  subTabMainToggle: '.sub-tab-main-toggle',
  variantSelectorEl: '.sub_tab_variant_selector',
  addToBoxButton: '.add-to-box',
  perTrayPrice: '.per-tray-price',
  willLast: '.will-last',
};

class buildABoxCard extends HTMLElement {

  constructor() {
    super();

    this.subTabMain = this.querySelector(selectors.subTabMain);
    this.subTabMainToggle = this.querySelector(selectors.subTabMainToggle);
    this.addToBoxButton = this.querySelector(selectors.addToBoxButton);
    this.variantSelectorEl = this.querySelector(selectors.variantSelectorEl);
    this.perTrayPrice = this.querySelectorAll(selectors.perTrayPrice);
    this.willLast = this.querySelectorAll(selectors.willLast);

    this.variantSelector();
    this.addToBox();
    this.calculatePerTrayPrice();
  }

  variantSelector() {
    if (!this.subTabMain.classList.contains("open")) {
      this.subTabMainToggle.addEventListener("click", () => {
        this.subTabMain.classList.toggle("open");
      });
    }

    const inputs = this.variantSelectorEl.querySelectorAll(".selectedvariant");
    inputs.forEach((input) => {
      input.onclick = () => {
        if (input.checked) {
          this.subTabMain.classList.remove("open");
          this.calculatePerTrayPrice();
        }
      };
    });

    document.addEventListener('click', (event) => {
      if (!this.subTabMain.contains(event.target) && !event.target.classList.contains("open")) {
        this.subTabMain.classList.remove("open");
      }
    });

    this.variantSelectorEl.addEventListener('click', () => {
      this.subTabMain.classList.toggle("open");
    });

    this.variantSelectorEl.addEventListener('change', (event) => {
      this.subTabMain.classList.toggle("open");
      this.addToBoxButton.setAttribute('data-variant-id', event.target.value);
      this.addToBoxButton.setAttribute('data-variant', event.target.getAttribute('data-variant'));
      this.addToBoxButton.setAttribute('data-variant-price', event.target.getAttribute('data-variant-price'));
      this.addToBoxButton.setAttribute('data-variant-compare-price', event.target.getAttribute('data-variant-compare-price'));
    });
  }

  calculatePerTrayPrice() {
    if (!this.variantSelectorEl.querySelector('input:checked')) {
      return;
    }

    const inputValue = this.variantSelectorEl.querySelector('input:checked').value;
    const perTrayPriceItems = Array.from(this.perTrayPrice).map((perTrayPrice) => perTrayPrice.getAttribute('data-variant-id'));
    const willLastItems = Array.from(this.willLast).map((willLast) => willLast.getAttribute('data-variant-id'));

    perTrayPriceItems.forEach((perTrayPriceItem, index) => {
      this.perTrayPrice[index].classList.remove("selected");
      if (inputValue === perTrayPriceItem) {
        this.perTrayPrice[index].classList.add("selected");
      }
    });

    willLastItems.forEach((willLastItem, index) => {
      this.willLast[index].classList.remove("selected");
      if (inputValue === willLastItem) {
        this.willLast[index].classList.add("selected");
      }
    });
  }

  addToBox() {
    // const firstBoxDiscount = window.QF.buildABox.firstBoxDiscount;

    this.addToBoxButton.addEventListener("click", (e) => {
      e.preventDefault();
      this.addToBoxButton.disabled = true;
      const productId = this.addToBoxButton.getAttribute("data-product-id");
      const productHandle = this.addToBoxButton.getAttribute("data-product-handle");
      const variant = JSON.parse(this.addToBoxButton.getAttribute("data-variant"));
      // const variantPrice = this.addToBoxButton.getAttribute("data-variant-compare-price") * firstBoxDiscount;
      const variantPrice = this.addToBoxButton.getAttribute("data-variant-price");
      const variantComparePrice = this.addToBoxButton.getAttribute("data-variant-compare-price");
  
      if (productHandle && variant.id) {
        const variantIds = JSON.parse(localStorage.getItem("build-a-box")) || [];
        const existingItemIndex = variantIds.findIndex(item => item.handle === productHandle && item.variant === variant.id);
        if (existingItemIndex === -1) {
          variantIds.push({
            id: parseInt(productId),
            handle: productHandle,
            variant: parseInt(variant.id),
            price: variantPrice,
            compare_at_price: variantComparePrice,
            quantity: 1,
            selling_plan: variant.selling_plan_allocations.map(spa => spa.selling_plan_id)
          });
        } else {
          variantIds[existingItemIndex].quantity++;
        }
        localStorage.setItem("build-a-box", JSON.stringify(variantIds));
  
        window.dispatchEvent(new CustomEvent("bab_updated"));
  
        setTimeout(() => {
          this.addToBoxButton.disabled = false;
        }, 2000);
      }
    });
  }
}

customElements.define("build-a-box-card", buildABoxCard);